import Network from 'utils/network';

export default {
  isCalendarIntegrated: () => Network.get(`/google-calendar/is-integrated/`),

  enableIntegration: enable => Network.post(`/google-calendar/enable/`, { enable }),
};
